import React, { useState, useEffect } from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCode,
  faMobile,
  faDatabase,
  faCloud,
  faServer,
  faWrench
} from '@fortawesome/free-solid-svg-icons';
import {
  faHtml5,
  faCss3Alt,
  faJs,
  faBootstrap,
  faJava,
  faPython,
  faAndroid,
  faGit
} from '@fortawesome/free-brands-svg-icons';

const skills = [
  { name: 'Java', icon: faJava },
  { name: 'Spring Boot', icon: faServer },
  { name: 'JavaScript', icon: faJs },
  { name: 'Python', icon: faPython },
  { name: 'Android', icon: faAndroid },
  { name: 'Google Cloud', icon: faCloud },
  { name: 'Firebase', icon: faDatabase },
  { name: 'HTML5', icon: faHtml5 },
  { name: 'CSS3', icon: faCss3Alt },
  { name: 'Bootstrap 5', icon: faBootstrap },
  { name: 'Git', icon: faGit },
  { name: 'Postman', icon: faWrench },
  { name: 'Full-Stack', icon: faCode },
  { name: 'Mobile Dev', icon: faMobile }
];

const Footer = () => {
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      setCurrentTime(timeString);
    };

    updateClock();
    const intervalId = setInterval(updateClock, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <footer className="modern-footer">
      <div className="footer-marquee-area">
        <div className="footer-gradient-left"></div>
        <div className="footer-marquee-track">
          <div className="marquee-content">
            {skills.map((skill, index) => (
              <div key={`s1-${index}`} className="marquee-badge">
                <FontAwesomeIcon icon={skill.icon} className="badge-icon" />
                <span>{skill.name}</span>
              </div>
            ))}
          </div>
          <div className="marquee-content" aria-hidden="true">
            {skills.map((skill, index) => (
              <div key={`s2-${index}`} className="marquee-badge">
                <FontAwesomeIcon icon={skill.icon} className="badge-icon" />
                <span>{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="footer-gradient-right"></div>
      </div>

      <div className="footer-bottom-bar">
        <div className="footer-left">
          <span className="footer-brand-title">Luigi Santiago</span>
          <span className="footer-brand-role">Software Developer</span>
        </div>

        <div className="footer-status-pill">
          <span className="footer-clock-dot"></span>
          <span>Philippines ({currentTime})</span>
        </div>

        <div className="footer-right">
          <p>© {new Date().getFullYear()} Luigi Santiago. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;